import { parseNonNegativeNumber } from './numberNormalizers';

export const normalizeIdToInt = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    const floored = Math.floor(value);
    return floored >= 0 ? floored : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const parsed = Number.parseInt(trimmed, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
  }

  return null;
};

export const normalizePriceToFloat = (value: unknown): number | null => {
  const parsed = parseNonNegativeNumber(value);
  return parsed === null ? null : parsed;
};

export const buildGameEnrichmentMaps = (
  gamesResponse: any[],
  activeGamesAndPacks?: any[] | null,
): {
  costByGameId: Map<string, number>;
  ticketsPerPackByGameId: Map<string, number>;
} => {
  const costByGameId = new Map<string, number>();
  const ticketsPerPackByGameId = new Map<string, number>();

  const applyGame = (game: any) => {
    const normalizedGameId = normalizeIdToInt(game?.game_id);
    if (normalizedGameId === null) return;

    const costPerTicket = normalizePriceToFloat(game?.cost_per_ticket);
    const ticketsPerPack = normalizeIdToInt(game?.tickets_per_pack);

    if (costPerTicket !== null) costByGameId.set(String(normalizedGameId), costPerTicket);
    if (ticketsPerPack !== null) ticketsPerPackByGameId.set(String(normalizedGameId), ticketsPerPack);
  };

  if (Array.isArray(gamesResponse)) {
    gamesResponse.forEach(applyGame);
  }

  if (Array.isArray(activeGamesAndPacks) && activeGamesAndPacks.length > 0) {
    // Store-specific data should override the global catalog when both exist.
    activeGamesAndPacks.forEach(applyGame);
  }

  return { costByGameId, ticketsPerPackByGameId };
};
